<div class="extend">
	<div class="container-generate">
		<h1 class="text-bold" style="color: white; font-weight: bolder;">Token</h1>
		<p class="display-5" style="color: gold; font-weight: bolder;" *ngIf="token">
			{{token}}
			<i class="fa fa-copy clickeable" tooltip="Copiar" (click)="copy()"></i>
		</p>
		<div class="container-generate generate" (click)="generate()">
			<div class="loading-container">
				<div class="loading-gradient" [class.loading]="loading"></div>
			</div>
			<p class="text-info">GENERAR
				{{token?'OTRO':''}} TOKEN</p>
		</div>
	</div>
</div>